import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { GoogleMap, useJsApiLoader, Marker } from '@react-google-maps/api';

import config from 'src/config';
import { remCss } from 'src/helpers';

const libraries = ['places'];
const googleMapsApiKey = (config.get('googleMaps') || {}).apiKey;

function GoogleMapsWithPlaceAutocomplete({ lat, lng, zoom = 16 }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey,
    libraries,
    preventGoogleFontsLoading: true
  });

  const [map, setMap] = useState(null);
  const markerPosition = useMemo(() => ({ lat, lng }), [lat, lng]);

  const onLoad = useCallback((mapInstance) => {
    setMap(mapInstance);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  useEffect(() => {
    if (map && lat && lng) {
      map.panTo(markerPosition);
    }
  }, [map, markerPosition, lat, lng]);

  const containerStyle = {
    width: '100%',
    height: `${remCss(400)}px`
  };

  return isLoaded ? (
    <div style={{ position: 'relative' }}>
      <GoogleMap
        mapContainerStyle={containerStyle}
        center={markerPosition}
        zoom={zoom}
        onLoad={onLoad}
        onUnmount={onUnmount}
      >
        <Marker position={markerPosition} />
      </GoogleMap>
    </div>
  ) : (
    <div>Loading...</div>
  );
}

export default React.memo(GoogleMapsWithPlaceAutocomplete);

export const StaticGoogleMap = ({ lat, lng, zoom = 16 }) => {
  return (
    <img
      src={`https://maps.googleapis.com/maps/api/staticmap?markers=color:red%7C${lat},${lng}&size=400x400&maptype=roadmap&zoom=${zoom}&key=${googleMapsApiKey}`}
    />
  );
};
